import { PreferredPaymentMethodEnum } from 'constants/user'
import { PreferredPaymentMethodType } from 'models/user'
import { ProductKind } from 'constants/product'

/** Typeguard stating if ProductKind is preferredPaymentMethod kind */
export function productKindIsPreferredPaymentMethod(kind: ProductKind): kind is PreferredPaymentMethodType {
  return kind in PreferredPaymentMethodEnum
}